
export const defaultKeywords = ``;

export const defaultFilters = {
    year: "",
    location: [],
    topic: [],
    affs: [],
    experts: [],
    advBoard: "",
    isActive: "",
    advanceSort: [],
    listType: {
        label: "SHORT LIST",
        value: "SHORT_LIST"
    },
    isActive:{},
    operator:  { value: "OR", label: "OR" },
    addedBy: [],
    size: 10,
    from: 0,
    sort: { value: "citation_count", label: "Citation" }
  }